<!-- SG-177 Phase 10 (review-round fix): thin redirect-only landing for the
     invitation email's deep link -- see contest-selection.component.ts for
     the routing logic; this template only ever renders for the instant it
     takes ngOnInit to redirect. PLACEHOLDER: pending Marc -- clean,
     functional loading state ahead of the real design mockup (see
     conventions.md). -->
<div class="cs-loading">
  <p><i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Loading your invitation&hellip;</p>
</div>
